"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* G5 (Rev 9): each user's order and visibility of a campaign's variable
 * columns, kept in this browser's localStorage. */





 const EMPTY_PREFS = { order: [], hidden: [] }; exports.EMPTY_PREFS = EMPTY_PREFS

 const columnPrefsKey = (userKey, campaignKey) =>
  `broadcast-columns:${userKey}:${campaignKey}`; exports.columnPrefsKey = columnPrefsKey

 const readColumnPrefs = (key) => {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return exports.EMPTY_PREFS
    const parsed = JSON.parse(raw) 
    return {
      order: Array.isArray(parsed.order) ? parsed.order.filter(n => typeof n === 'string') : [],
      hidden: Array.isArray(parsed.hidden) ? parsed.hidden.filter(n => typeof n === 'string') : [],
    }
  } catch (e) {
    return exports.EMPTY_PREFS
  }
}; exports.readColumnPrefs = readColumnPrefs

 const writeColumnPrefs = (key, prefs) => {
  try { localStorage.setItem(key, JSON.stringify(prefs)) } catch (e2) { /* private mode: not kept */ }
}; exports.writeColumnPrefs = writeColumnPrefs

/* The campaign's variables in the user's order: saved ones first (dropping
 * variables that no longer exist), then any new ones in declaration order. */
 const arrangeColumns = (names, prefs) => {
  const known = new Set(names)
  const saved = prefs.order.filter(n => known.has(n))
  const seen = new Set(saved)
  return [...saved, ...names.filter(n => !seen.has(n))]
}; exports.arrangeColumns = arrangeColumns

/* Moves `name` to sit before `before` (or last when `before` is null). */
 const moveColumn = (order, name, before) => {
  if (name === before) return order
  const rest = order.filter(n => n !== name)
  const at = before === null ? rest.length : rest.indexOf(before)
  return at < 0 ? order : [...rest.slice(0, at), name, ...rest.slice(at)]
}; exports.moveColumn = moveColumn
